import { SimulatorPage } from "@pages/SimulatorPage";

function App() {
  return (
    <div className="app-root">
      <SimulatorPage />
    </div>
  );
}

export default App;